import React from 'react'

export function PriceTypeHeader({ nested, heading, category }) {
  return (
    <div className={'price-type-header' + (nested ? ' nested' : '')}>
      {nested ? <span className="sr-only">{category} </span> : null}
      {heading}
    </div>
  )
}
